module.exports = __webpack_public_path__ + "530e34640c7700d3f3289c1da767d995.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/history/2.jpg
// module id = 287
// module chunks = 0